export const isEmpty = (obj: any) => Object.keys(obj).length === 0;